(function () {
  function pushEvent(name, details) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, details || {}));
    if (typeof window.gtag === 'function') window.gtag('event', name, details || {});
  }

  function isSaleVariant(variant) {
    if (!variant) return false;
    var price = Number(variant.price || 0);
    var compareAt = Number(variant.compare_at_price || 0);
    return compareAt > price;
  }

  function syncFinalSale(form, variant) {
    if (!form) return;
    var finalSale = isSaleVariant(variant);
    var note = form.querySelector('[data-final-sale-note]');
    var property = form.querySelector('[data-final-sale-property]');
    if (note) note.hidden = !finalSale;
    if (property) property.disabled = !finalSale;
  }

  document.addEventListener('variants:change', function (event) {
    var form = event.target && event.target.closest('.product-single__box')
      ? event.target.closest('.product-single__box').querySelector('form[action*="/cart/add"]')
      : document.querySelector('.product-single form[action*="/cart/add"]');
    syncFinalSale(form, event.detail && event.detail.variant);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('form[role="search"]')) return;
    var input = form.querySelector('input[name="q"]');
    pushEvent('rooster_search_submit', { search_term: input ? input.value.trim() : '' });
  });

  document.addEventListener('click', function (event) {
    var tracked = event.target.closest('[data-rooster-event]');
    if (tracked) pushEvent(tracked.getAttribute('data-rooster-event'), { link_url: tracked.href || '' });

    var pickup = event.target.closest('pickup-availability, .store-availability-container, [data-store-availability-modal-open]');
    if (pickup) pushEvent('rooster_pickup_interest');

  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.closest('.promo-page, [data-section-type="newsletter"], .klaviyo-form')) return;
    pushEvent('rooster_promo_signup_submit');
  });

  if (window.jQuery) {
    window.jQuery(document.body).on('afterAddItem.ajaxCart', function (event, lineItem) {
      var properties = lineItem && lineItem.properties;
      pushEvent('rooster_add_to_cart', {
        product_id: lineItem ? String(lineItem.product_id || '') : '',
        variant_id: lineItem ? String(lineItem.variant_id || '') : '',
        quantity: lineItem ? Number(lineItem.quantity || 1) : 1,
        value: lineItem ? Number(lineItem.final_price || lineItem.price || 0) / 100 : 0,
        currency: window.Shopify && Shopify.currency ? Shopify.currency.active : '',
        final_sale: !!(properties && (properties._final_sale === true || properties._final_sale === 'true'))
      });
    });
  }
})();
